module.exports = __webpack_public_path__ + "img/sy.73690f50.svg";